import { Injectable } from '@angular/core';

@Injectable()
export class ModelParserService {
    getVehicle = (data) => {
        if (data.title) {
            return data.title.vehicleOwnership.vehicle;
        } else if (data.registration) {
            return data.registration.vehicleOwnershipPlate.vehicleOwnership.vehicle;
        } else if (data.vehicleOwnership) {
            return data.vehicleOwnership.vehicle;
        } else if (data.vehicle) {
            return data.vehicle;
        } else {
            return data;
        }
    };

}
